module.exports = __webpack_public_path__ + "static/logo2-60ebecd50ecfc80067cdd65775adb0ec.jpg";